import { createInjectionHooks } from 'brandi-react';

import { TOKENS } from '../../setup/brandi';

const [
  useUserService,
  useAuthService,
  useAppointmentService,
  useDoctorService,
  usePatientService,
  useSessionService,
  useSpecialtyService
] = createInjectionHooks(
  TOKENS.userService,
  TOKENS.authService,
  TOKENS.appointmentService,
  TOKENS.doctorService,
  TOKENS.patientService,
  TOKENS.sessionService,
  TOKENS.specialtyService
);

export {
  useUserService,
  useAuthService,
  useAppointmentService,
  useDoctorService,
  usePatientService,
  useSessionService,
  useSpecialtyService
};
